import * as React from "react";
const SvgTriangleRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 10, viewBox: "0 0 5 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Polygon 1", d: "M4.90723 5L0.476621 9.26335L0.476622 0.736646L4.90723 5Z", fill: "#272727" }));
export default SvgTriangleRight;
